import {Icon as ChakraIcon} from "@chakra-ui/react"

import {
    FaDirections,
    FaList,
    FaNetworkWired,
    FaRegCheckCircle,
    FaRegUser,
    FaStore,
    FaTrophy,
    FaWhatsapp
} from 'react-icons/fa'
import {
    MdAddCircle,
    MdCached,
    MdCancel,
    MdDarkMode,
    MdLabel,
    MdLightMode,
    MdLogout,
    MdOutlineEdit,
    MdOutlineFileUpload,
    MdOutlineInventory2,
    MdOutlineLocalShipping,
    MdOutlineMail,
    MdOutlinePix,
    MdOutlineSupervisedUserCircle,
    MdOutlineSupportAgent,
    MdOutlineVisibility,
    MdOutlineVisibilityOff,
    MdOutlineWorkspacePremium,
    MdPayments,
    MdRemoveCircle
} from "react-icons/md"
import {
    IoAlertCircleOutline,
    IoAttach,
    IoBagHandleOutline,
    IoCameraOutline,
    IoCloseCircleOutline,
    IoDiscOutline,
    IoHomeOutline,
    IoKeyOutline,
    IoMenu,
    IoOpenOutline,
    IoPrintOutline,
    IoSearchOutline,
    IoShareSocialOutline,
    IoTimeOutline
} from "react-icons/io5"
import {AiFillBank} from "react-icons/ai"
import {BiMoneyWithdraw} from "react-icons/bi"
import {TbMoneybag, TbReload, TbReportSearch} from "react-icons/tb"
import {RiEmotionLine} from "react-icons/ri"
import {FiTrash2} from "react-icons/fi"
import {LuChevronsDown, LuChevronsUp, LuTimer} from "react-icons/lu"
import {CiCircleInfo} from "react-icons/ci"
import {IoIosArrowRoundBack, IoIosArrowRoundForward, IoIosLink, IoIosNotificationsOutline} from "react-icons/io"
import {SiGoogleanalytics, SiMercadopago} from "react-icons/si"
import {HiAdjustmentsHorizontal} from "react-icons/hi2"
import {PiIdentificationBadge, PiUserList} from "react-icons/pi"
import {BsDatabaseFillExclamation, BsFiletypeCsv} from "react-icons/bs";
import {FaRegFilePdf} from "react-icons/fa6";

export default function Icon({name, ...props}) {

    let icon;

    switch(name){
        default: case 'home': icon = IoHomeOutline; break;
        case 'menu': icon = IoMenu; break;
        case 'support': icon = MdOutlineSupportAgent; break;
        case 'share': icon = IoShareSocialOutline; break;
        case 'settings': case 'config': case 'adjusts': icon = HiAdjustmentsHorizontal; break;
        case 'profile': case 'user': icon = FaRegUser; break;
        case 'bank': icon = AiFillBank; break;
        case 'cache': icon = MdCached; break;
        case 'withdraw': icon = BiMoneyWithdraw; break;
        case 'bonus': icon = TbMoneybag; break;
        case 'network': icon = FaNetworkWired; break;
        case 'points': case 'point': icon = FaTrophy; break;
        case 'anticipation': case 'anticipations': icon = TbReload; break;
        case 'store': icon = FaStore; break;
        case 'order': case 'orders': icon = FaList; break;
        case 'voucher': case 'vouchers': icon = MdLabel; break;
        case 'dark': icon = MdDarkMode; break;
        case 'light': icon = MdLightMode; break;
        case 'logout': icon = MdLogout; break;
        case 'active': icon = RiEmotionLine; break;
        case 'visible': icon = MdOutlineVisibility; break;
        case 'hidden': icon = MdOutlineVisibilityOff; break;
        case 'cancel': case 'canceled': icon = MdCancel; break;
        case 'waiting': icon = IoTimeOutline; break;
        case 'double-chevron-down': icon = LuChevronsDown; break;
        case 'double-chevron-up': icon = LuChevronsUp; break;
        case 'trash': icon = FiTrash2; break;
        case 'pdf': icon = FaRegFilePdf; break;
        case 'csv': icon = BsFiletypeCsv; break;
        case 'check': case 'done': icon = FaRegCheckCircle; break;
        case 'analytics': case 'reports': icon = SiGoogleanalytics; break;
        case 'close': icon = IoCloseCircleOutline; break;
        case 'no-data': icon = BsDatabaseFillExclamation; break;
        case 'upload': icon = MdOutlineFileUpload; break;
        case 'timer': icon = LuTimer; break;
        case 'add': icon = MdAddCircle; break;
        case 'remove': icon = MdRemoveCircle; break;
        case 'print': icon = IoPrintOutline; break;
        case 'info': icon = CiCircleInfo; break;
        case 'search': icon = IoSearchOutline; break;
        case 'edit': icon = MdOutlineEdit; break;
        case 'mercadopago': icon = SiMercadopago; break;
        case 'cielo': icon = MdPayments; break;
        case 'whatsapp': icon = FaWhatsapp; break;
        case 'inventory': icon = MdOutlineInventory2; break;
        case 'notification': icon = IoIosNotificationsOutline; break;
        case 'directions': icon = FaDirections; break;
        case 'popup': icon = IoOpenOutline; break;
        case 'attach': icon = IoAttach; break;
        case 'link': icon = IoIosLink; break;
        case 'pix': icon = MdOutlinePix; break;
        case 'key': case 'pix_key': icon = IoKeyOutline; break;
        case 'camera': icon = IoCameraOutline; break;
        case 'alert': icon = IoAlertCircleOutline; break;
        case 'analyzing': icon = IoDiscOutline; break;
        case 'identity': icon = PiIdentificationBadge; break;
        case 'mail': case 'email': icon = MdOutlineMail; break;
        case 'shipping': case 'transit': icon = MdOutlineLocalShipping; break;
        case 'best-selling': icon = MdOutlineWorkspacePremium; break;
        case 'more-client': icon = PiUserList; break;
        case 'report-general': icon = TbReportSearch; break;
        case 'third': icon = MdOutlineSupervisedUserCircle; break;
        case 'cart': case 'bag': icon = IoBagHandleOutline; break;
        case 'right': case 'next': icon = IoIosArrowRoundForward; break;
        case 'left': case 'prev': icon = IoIosArrowRoundBack; break;
    }

    return <ChakraIcon as={icon} {...props} />
}